<script setup>
import {ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {CountTo} from "vue3-count-to";
import router from "@/router/index.js";

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  salesChannel: null,
  categoryType: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    // const res = await itemListIgnore(param.value, formData);
    tableData.value = []
    // tableData.value = res.list
    // total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.salesChannel = null
  formData.categoryType = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 按车辆品牌查看headers
const brandHeaders = [
  { title: '车辆品牌', key: 'goodsName', nowrap: true },
  { title: '车辆型号', key: 'tenantName', nowrap: true },
  { title: '车辆颜色', key: 'innerCategoryName', nowrap: true },
  { title: '车辆使用年龄段', key: 'salesChannelShow', nowrap: true },
  { title: '车辆新旧程度', key: 'salesChannelShow', nowrap: true },
  { title: '提供方/赞助方', key: 'crTime', nowrap: true },
  { title: '车辆当前放置场地', key: 'state', nowrap: true },
  { title: '车辆放置时间', key: 'crTime', nowrap: true },
  { title: '车辆数量', key: 'state', nowrap: true },
  { title: '车辆绑定占比', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', minWidth: '100px', fixed: true },
]
// 按赞助方查看
const sponsorHeaders = [
  { title: '提供方/赞助方', key: 'crTime', nowrap: true },
  { title: '车辆品牌', key: 'goodsName', nowrap: true },
  { title: '车辆型号', key: 'tenantName', nowrap: true },
  { title: '车辆颜色', key: 'innerCategoryName', nowrap: true },
  { title: '车辆使用年龄段', key: 'salesChannelShow', nowrap: true },
  { title: '车辆新旧程度', key: 'salesChannelShow', nowrap: true },
  { title: '车辆当前放置场地', key: 'state', nowrap: true },
  { title: '车辆放置时间', key: 'crTime', nowrap: true },
  { title: '车辆数量', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', minWidth: '100px', fixed: true },
]
const headers = ref(brandHeaders)
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 当前选择的标签卡
const tab = ref("brand")
// 处理切换标签、标签组选项卡
const handleTabChange = (e) => {
  console.log("e", e)
  if (e === 'brand') {
    headers.value = brandHeaders
  } else {
    headers.value = sponsorHeaders
  }
  handleReset()
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/addBicycleInventory")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;gap: 15px;">
      <v-btn color="success" @click="handleAdd">
        <template v-slot:default>
          <div class="flex_bt">
            <img
                style="width: 14px; height: 14px; margin-right: 4px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
            />
            <span>新增车辆</span>
          </div>
        </template>
      </v-btn>
      <v-btn color="success" @click="handleAdd">批量导入车辆</v-btn>
      <el-link type="primary">导入模板下载</el-link>
    </div>
  </div>
  <div class="container_box flex mg_b_2" style="padding: 16px;">
    <div class="dataBox mg_r_2" style="position: relative">
      <div class="dataBox_SubTitle">车辆总数</div>
      <countTo
          :title="0"
          class="dataBox_title txt_overflow"
          :startVal="0"
          :endVal="parseInt(100)"
          :duration="3000"
      ></countTo>
    </div>
    <div class="dataBox mg_r_2" style="position: relative">
      <div class="dataBox_SubTitle">已绑定车辆</div>
      <countTo
          :title="0"
          class="dataBox_title txt_overflow"
          :startVal="0"
          :endVal="parseInt(100)"
          :duration="3000"
      ></countTo>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="11">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="start">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.keyword"
                        placeholder="请输入车辆品牌"
                        label="车辆品牌"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.keyword"
                        placeholder="请输入车辆型号"
                        label="车辆型号"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'goods:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'goods:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <div class="flex_bt">
              <v-tabs
                  class="mg_r_3"
                  v-model="tab"
                  color="primary"
                  @update:modelValue="handleTabChange"
              >
                <v-tab value="brand">按车辆品牌查看</v-tab>
                <v-tab value="sponsor">按赞助方查看</v-tab>
              </v-tabs>
              <v-btn color="success">下载</v-btn>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>

</style>
